export function remove<T>(arr:Array<T>,item:T):Array<T> {
    var index=arr.indexOf(item);
    return [
      ...arr.slice(0,index),
      ...arr.slice(index+1) 
    ]; 
  }
  
  export function replace<T>(arr:Array<T>,item:T,newItem:T):Array<T> {
    var index=arr.indexOf(item);
    return [
      ...arr.slice(0,index),
      newItem,
      ...arr.slice(index+1)
    ];
  }
  
  export function insertAfter<T>(arr:Array<T>,index:number,item:T){
    return [
      ...arr.slice(0,index+1), 
      item,
      ...arr.slice(index+1)
    ];
  }
  export function insertBefore<T>(arr:Array<T>,index:number,item:T){
    return [
      ...arr.slice(0,index), 
      item,
      ...arr.slice(index)
    ];
  }

  